/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Hero_CtaInputs */

const en_cp_hero_cta = /** @type {(inputs: Cp_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply for a partnership`)
};

const id_cp_hero_cta = /** @type {(inputs: Cp_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajukan kerjasama`)
};

/**
* | output |
* | --- |
* | "Apply for a partnership" |
*
* @param {Cp_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_hero_cta = /** @type {((inputs?: Cp_Hero_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Hero_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_hero_cta(inputs)
	return en_cp_hero_cta(inputs)
});